// React Hooks
import { useContext } from "react";

// Api Connector Functions
import { ApiGetCall, ApiPostCall } from "../JS/Connector";

// App Contexts
import { UserContext } from "../App";

// Custom React Hook
import useConfig from "./useConfig";

// Redux and Redux Functions
import { useDispatch } from "react-redux";
import { setDefaultShippingMethod } from "../Store/Slices/authSlice";

// Custom Components
import AlertsComp from "../Components/AlertsComp";

// ---- Default Shipping Method ----
function useDefaultShipMethodCall() {
    const { UserData, setUserData } = useContext(UserContext);
    const reduxDispatch = useDispatch();

    async function DefaultShipMethodCall(SchoolId, defaultShipMethod, setLoading, setNewAlerts) {
        if (setLoading) {
            setLoading(true);
        }
        var raw = JSON.stringify({
            schoolId: SchoolId,
            flag: defaultShipMethod
        });
        await ApiPostCall("/settings/set-default-shipping-method", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                if (setLoading) {
                    setLoading(false);
                }
                if (result == "success") {
                    if (setNewAlerts) {
                        setNewAlerts(<AlertsComp show={true} variant="success" msg={"Default Shipping Method Updated Successfully"} />);
                    }
                    setTimeout(() => {
                        setUserData((prevUserData) => ({ ...prevUserData, defaultShipMethod: defaultShipMethod }));
                        if (UserData.copyaccesstype != null) {
                            reduxDispatch(setDefaultShippingMethod(defaultShipMethod));
                        }
                        if (setNewAlerts) {
                            setNewAlerts(<AlertsComp show={false} />);
                        }
                    }, 1500);
                } else {
                    if (setNewAlerts) {
                        setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                        setTimeout(() => {
                            setNewAlerts(<AlertsComp show={false} />);
                        }, 2000);
                    }
                }
            }
        });
    }

    return { DefaultShipMethodCall };
}

function useGetCustomFieldsName() {
    const { adminCallNode } = useConfig();
    async function AllCustomFieldNamesColor(setCustomFieldNames, isFilterOut) {
        await ApiGetCall(`${adminCallNode}/custom-fields/names`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                let filtered = responseRs;
                if (isFilterOut) {
                    filtered = (responseRs?.length > 0 ? responseRs : []).filter(item => item.function_type_code == 1);
                }
                setCustomFieldNames(filtered);
            }
        });
    }

    return { AllCustomFieldNamesColor };
}

export { useDefaultShipMethodCall, useGetCustomFieldsName };